import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Button from "../components/Button";
import "../assets/languages/i18n";
import {
  Box,
  Grid,
  Paper,
  Toolbar,
  Typography,
} from "@mui/material";
import LoginBG from "../../src/assets/images/bg.svg";
import LoginLogo1 from "../../src/assets/images/login/design-stats-pana-2.png";
import { useDispatch, useSelector } from "react-redux";
import { makeStyles } from "@mui/styles";
import * as Util from "../services/global.service";

import {
  postSsoLoginCallback
} from "../actions/start";
import { logout } from "../actions/auth";


const styles = {
  toolBar: {
    paddingLeft: "5px",
  },
  childToolBar: {
    padding: "32px 20px",
    fontWeight: "400",
  },
  title: {
    paddingBottom: "15px",
  },
  subTitle: {
    color: "#282C40 !important",
  },
};

const useStyles = makeStyles({
  error: {
    color: " #CC6058 !important",
    "& div > p": {
      color: " #CC6058 !important",
      fontSize: "14px",
      lineHeight: "15.4px",
      marginLeft: 0,
    },
    "& > p": {
      color: " #CC6058 !important",
      fontSize: "14px",
      lineHeight: "15.4px",
      marginLeft: 0,
    },
    "& div > input": {
      fontSize: "14px",
      lineHeight: "15.4px",
    },
    "& div > label": {
      color: "#0C2B34",
      fontSize: "16px",
      lineHeight: "17.6px",
      fontWeight: "500",
    },
  },
});

const SsoOauthCallback = () => {
  const classes = useStyles();
  const { t, i18n } = useTranslation()
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isSsoError, setIsSsoError] = useState(false);

  let language = localStorage.getItem("lang");
  const [query] = useSearchParams();
  const user = useSelector((state) => state?.auth);


  useEffect(() => {
    if (user?.isLoggedIn ?? false) {
      if (user?.user?.consent ?? false) {
        navigate('/kpi/home', { replace: false });
      } else {
        navigate("/consent", { replace: false });
      }
    } else {
      if (query.get("error") && query.get("error_description")) {
        console.error('SSO', query.get("error"), query.get("error_description"))
        setIsSsoError(true)

        dispatch(logout()).then(
          (response) => {
            let pathTologin = response?.data?.data?.url
            if (Util.formatData(pathTologin, false) !== false) {
              const newWindow = window.open(pathTologin, '_self', 'noopener,noreferrer')
              if (newWindow) newWindow.opener = null
            } else {
              console.log('Navigate', 15);
              //navigate('/' + localStorage.getItem("site"), { replace: false });
              //window.location.href = '/' + localStorage.getItem("site")
            }
          }
        ).catch((err) => {
          localStorage.removeItem('date');
          localStorage.removeItem('user');
          localStorage.removeItem("proxy");
          console.log('Navigate', 16);
          //navigate('/' + localStorage.getItem("site"), { replace: false });
          window.location.href = '/' + localStorage.getItem("site")
        })

      } else if (query.get("code") && query.get("state")) {
        let reqBody = {
          code: query.get("code"),
          state: query.get("state")
        }
        dispatch(postSsoLoginCallback(reqBody)).then((resp) => {

          if (resp?.custom?.language) {
            localStorage.setItem('custom_language', JSON.stringify(resp?.custom?.language))
            for (const lang of resp?.custom?.language) {
              let key = lang.code.split('.')
              let ns = 'translation'// key.shift()

              if (ns && key.length > 0) {
                let this_lang = (lang.language === 'th') ? 'th-TH' : 'en-US'
                i18n.addResource(this_lang, ns, key.join('.'), lang.value + '')
              }
            }
          }

          if (resp.language) {
            language = (resp.language === 'en') ? 'en-US' : 'th-TH'
            localStorage.setItem('lang', language)
            i18n.changeLanguage(language)
          }



          if (resp.consent === true) {
            navigate("/kpi/home", { replace: false });
          } else {
            navigate("/consent", { replace: false });
          }
        }).catch(err => {
          console.error('SSO', err)
          setIsSsoError(true)
        })
      } else {
        setIsSsoError(true)
      }
    }
  }, [])

  return (
    <>
      <Helmet>
        <title>Authenicationing | PMS</title>
      </Helmet>
      <Grid
        container
        sx={{
          height: "100%",
          backgroundImage: `url(${LoginBG})`,
          "background-size": "cover",
        }}
      >
        <Grid
          container
          item
          sx={{
            display: "flex",
            flexDirection: { xs: "column", lg: "row" },
            alignItems: "center",
            overflow: "hidden",
            boxShadow: 0,
            fontWeight: "bold",
          }}
        >
          <Grid
            container
            item
            xs={12}
            lg={6}
            justifyContent="center"
            sx={{ display: { sm: "none", lg: "flex" } }}
            alignItems="center"
          >
            <img src={LoginLogo1} />
          </Grid>
          <Grid container item xs={12} lg={4} spacing={4} sx={{}}>
            <Grid
              direction="column"
              sx={{}}
              container
              item
              justifyContent="center"
              alignItems="center"
            >
              <Grid container item sx={{}}>
                <Paper
                  elevation={6}
                  sx={{ padding: "50px", "border-radius": "20px" }}
                  classes={{ root: classes.error }}
                >
                  <Grid container>
                    {
                      !isSsoError ?
                        (
                          <Grid item xs sx={{ marginTop: "30px" }}>
                            <Typography
                              color="primary"
                              variant="h2"
                              style={styles.title}
                              fontSize={36}
                              lineHeight="39.6px"
                            >
                              กำลังลงชื่อเข้าใช้
                            </Typography>
                            <Typography
                              color="textSecondary"
                              gutterBottom
                              variant="h2"
                              style={styles.subTitle}
                              fontSize={16}
                              fontWeight={300}
                              lineHeight="17.6px"
                            >
                              โปรดรอสักครู่...
                            </Typography>
                          </Grid>
                        )
                        : (
                          <Grid item xs sx={{ marginTop: "30px" }}>
                            <Typography
                              color="primary"
                              variant="h2"
                              style={styles.title}
                              fontSize={36}
                              lineHeight="39.6px"
                            >
                              ลงชื่อเข้าใช้ไม่สำเร็จ
                            </Typography>
                            <Typography
                              color="textSecondary"
                              gutterBottom
                              variant="h2"
                              style={styles.subTitle}
                              fontSize={16}
                              fontWeight={300}
                              lineHeight="17.6px"
                            >
                              กรุณาติดต่อเจ้าหน้าที่เพื่อดำเนินการต่อไป
                            </Typography>
                          </Grid>
                        )
                    }
                    <Grid container>
                      <Grid item xs sx={{ marginTop: "30px" }}>
                        <Button
                          color="primary"
                          fullWidth
                          size="large"
                          type="submit"
                          variant="contained"
                          disabled={!isSsoError}
                          onClick={() => navigate("/", { replace: false })}
                        >
                          {t("consent.label.backToLogin")}
                        </Button>
                      </Grid>
                    </Grid>
                  </Grid>
                </Paper>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        {/*footer*/}
        <Grid
          container
          item
          sx={{
            bottom: 0,
          }}
        >
          <Toolbar
            color="primary"
            sx={{ "align-items": "end", "padding-left": "5px" }}
            style={styles.toolBar}
          >
            <Typography
              variant="h6"
              component="div"
              sx={{ flexGrow: 0 }}
              p={4}
              style={styles.childToolBar}
            >
              Copyright 2021 I AM Consulting Co., Ltd. All Rights Reserved
            </Typography>
            <Typography
              variant="h6"
              component="div"
              sx={{ flexGrow: 0 }}
              p={4}
              style={styles.childToolBar}
            >
              Privacy Policy
            </Typography>
            <Typography
              variant="h6"
              component="div"
              sx={{ flexGrow: 0 }}
              p={4}
              style={styles.childToolBar}
            >
              Terms of Service
            </Typography>
          </Toolbar>
        </Grid>
      </Grid>
    </>
  );
};
export default SsoOauthCallback;
